import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProviderBrandsSearchResponseInterface } from '../../interfaces/blog/provider-brands-search';
import { environment } from '../../../../environments/environment';
import { catchError, of, tap } from 'rxjs';
import { BrandMappingInterface } from '../../interfaces/brands/brands-interface';
import { StoreRefreshService } from '../../store/store-refresh-service/store-refresh.service';
import { GlobalMessageService } from '../global-services/global-message-service/global-message.service';

@Injectable({
  providedIn: 'root',
})
export class BrandMappingsService {
  storeRefreshService = inject(StoreRefreshService);
  globalMessageService = inject(GlobalMessageService);
  constructor(private http: HttpClient) {}

  refreshRequest = (status: boolean) => {
    if (status) {
      this.storeRefreshService.brandRefreshRequest$.set(+new Date());
    }
  };

  add = (request: BrandMappingInterface) => {
    return this.http
      .post<ProviderBrandsSearchResponseInterface>(
        `${environment.baseUrl}/brandMappings/add`,
        request
      )
      .pipe(
        catchError(() => {
          return of({
            RedisProviderBrandRoot: null,
            Data: [],
            IsPaging: false,
            Status: 0,
            Page: {
              CurrentPage: 0,
              TotalPage: 0,
              ItemCount: 0,
              TotalItemCount: 0,
            },
            ShowingMessage: 'Marka eşleştirme ekleme işlemi başarısız oldu',
            InternalMessage: null,
            Details: {
              QuestStatus: '',
            },
          } as ProviderBrandsSearchResponseInterface);
        }),
        tap((f) => {
          this.globalMessageService.showStatusMessages({
            status: !!f && f.Status === 1,
            summary: 'Marka Eşleştirmesi Ekle',
            infoDetail: `Marka Eşleştirmesi Başarıyla Eklendi.`,
            errorDetail: `Marka Eşleştirmesi Ekleme İşlemi Başarısız Oldu.`,
          });
          this.refreshRequest(!!f && f.Status === 1);
        })
      );
  };

  update = (brandMapping: BrandMappingInterface) => {
    return this.http
      .post<BrandMappingInterface>(
        `${environment.baseUrl}/brandMappings/update`,
        brandMapping
      )
      .pipe(
        catchError(() => {
          return of(brandMapping);
        }),
        tap((f) => {
          this.globalMessageService.showStatusMessages({
            status: !!f?.Id,
            summary: 'Marka Eşleştimesi Güncelle',
            infoDetail: `Marka Eşleştirmesi Başarıyla Güncellendi.`,
            errorDetail: `Marka Eşleştirmesi Güncelleme İşlemi Başarısız Oldu.`,
          });
          this.refreshRequest(!!f?.Id);
        })
      );
  };

  delete = (brandMapping: BrandMappingInterface) => {
    return this.http
      .post<{ success: boolean }>(
        `${environment.baseUrl}/brandMappings/delete`,
        brandMapping
      )
      .pipe(
        catchError(() => {
          return of({ success: false });
        }),
        tap((f) => {
          this.globalMessageService.showStatusMessages({
            status: f.success,
            summary: 'Marka Eşleştimesi Sil',
            infoDetail: `Marka Eşleştirmesi Başarıyla Silindi!`,
            errorDetail: `Marka Eşleştirmesi Silme İşlemi Başarısız Oldu.`,
          });
          this.refreshRequest(f.success);
        })
      );
  };
}
